import getStore from 'services/getStore';

export default (type, key = null) => {
  const blocks = Object.values(getStore().getState().blocks).filter(
    (b: any) => b.type === type
  );
  return key ? blocks.map((a: any) => a[key]) : blocks;
};
